import { useTranslation } from "react-i18next";
import { Col, Row } from 'react-bootstrap';
import PageTitle from "../../../layouts/PageTitle";
import TransactionCashFlowHistory from "../../../components/Custom/CashFlow/Transaction/TransactionCashFlowHistory";

const TransactionCashFlowList = () => {

    const { t } = useTranslation();

    return (
        <>
            <PageTitle activeMenu={t('cash_flow.transactions')} motherMenu={t('cash_flow.label')} />
            <Row>
                <Col className="col-md-12">
                    <TransactionCashFlowHistory/>
                </Col>
            </Row>
        </>
    );
}

export default TransactionCashFlowList;